import EventDispatcher from '../../../../../shared/lib/html5-software-library/src/ranj/util/EventDispatcher';
import ScoreCalculator from './ScoreCalculator';

export default class PuzzleModel extends EventDispatcher {

    /**
     * 
     * @param {Object} puzzleConfig - object (parsed json)
     * @param {ScoreCalculator} scoreCalculator
     */
    constructor(puzzleConfig, scoreCalculator) {
        super();
        this._config = puzzleConfig;
        this._scoreCalculator = scoreCalculator;
        this.reset();
    }

    get id() {
        return this._config.id;
    }

    get config() {
        return this._config;
    }

    /**@type {Array<string>} Array of item ids.*/
    get goal() {
        return this._config.goal;
    }

    /**@type {Array<string>} Array of item ids.*/
    get items() {
        return this._config.items;
    }

    get slots() {
        return this._slots;
    }

    /**@type {Number} in range [0..1].*/
    get score() {
        return this._score;
    }

    reset() {
        this._slots = [];
        for (let i = 0; i < this.goal.length; i++) {
            this._slots.push(null);
        }
        if (this._config.initialState) {
            this._applyState(this._config.initialState);
        }
        this._updateScore();
    }

    getItemInSlot(index) {
        return this._slots[index];
    }

    clearSlot(index) {
        this.fillSlot(index, null);
        this._updateScore();
    }

    fill(items) {
        items.forEach((item, index) => this.fillSlot(index, item));
    }

    fillSlot(index, item = null) {
        this._slots[index] = item;
        this._updateScore();
    }

    _applyState(state) {
        this.fill(state);
        this._updateScore();
    }

    getState() {
        //TODO
        return this._slots;
    }


    /*****************************
     *      SCORING RELATED
     *****************************/

    _updateScore() {
        this._score = this._scoreCalculator.calculatePuzzleScore(this._config.goal, this._slots);
    }


    /*****************************
     *      SAVEGAME RELATED
     *****************************/

    toObject() {
        //make state serializable (convert Sets into Arrays)
        const state = this.getState();
        return {
            state: state,
            moveCount: this.moveCount
        }
    }

    /**
     * 
     * @param {Object} object - see keys in PuzzleModel.toObject()
     */
    setFromObject(object) {
        this._moveCount = moveCount;
        const state = object.state;
        if (state) {
            this._applyState(state);
        }
    }
}